import { ANSWERS } from '@wellbeingxltd/fe-lib/constants'
import { ACTIONS } from 'actions/assessment'

export const initialState = {
    appState: {
        state: 'IDLE',
        answers: [],
        index: 0,
        postingAssessmentUpdate: false,
        postAssessmentUpdateError: null,
        getAssessmentLoading: false,
        getAssessmentUpdatesLoading: false,
        getAssessmentUpdatesError: null,
        onboardingAnswers: {
            assessment: [],
            pillarSelected: '',
            goalTag: '',
            postOnboardingNavigationChoice: '',
            postCode: null,
            genderIdentity: null,
            yearOfBirth: null,
        },
    },

    database: {
        assessments: [],
        assessmentScores: [],
        assessmentsIds: [],
        assessmentsDates: [],
        assessmentsObjects: [],
        assessmentsUpdate: [],
        assessmentsUpdateIds: [],
        assessmentsUpdateDates: [],
        assessmentsUpdateObjects: [],
        assessmentTemplate: {
            assessment: [],
        },
        onboardingTemplate: {
            onboardingSteps: [],
            index: 0,
            assessmentList: [],
        },
    },
}

export default (state = initialState, action) => {
    const { appState, database } = state
    const { index } = appState
    const { assessment } = database.assessmentTemplate
    let newAppState = { ...appState }

    switch (action.type) {
        case ACTIONS.GET_ASSESSMENT_TEMPLATE:
            return {
                ...state,
                database: { ...database, assessmentTemplate: action.data },
            }
        case ACTIONS.GET_ONBOARDING_TEMPLATE:
            return {
                ...state,

                database: { ...database, onboardingTemplate: { ...database.onboardingTemplate, onboardingSteps: action.data } },
            }

        case ACTIONS.SET_ONBOARDING_STEP:
            return {
                ...state,
                database: { ...database, onboardingTemplate: { ...database.onboardingTemplate, index: action.data } },
            }
        case ACTIONS.CHANGE_ONBOARDING_STEP_STATE:
            return {
                ...state,
                database: {
                    ...database,
                    onboardingTemplate: {
                        ...database.onboardingTemplate,
                        onboardingSteps: database.onboardingTemplate.onboardingSteps.map(step =>
                            step.index == action.data.number ? { ...step, disable: action.data.state } : step
                        ),
                    },
                },
            }
        case ACTIONS.SET_ONBOARDING_ANSWERS:
            switch (action.change) {
                case 'assessment':
                    return {
                        ...state,
                        appState: { ...appState, onboardingAnswers: { ...appState.onboardingAnswers, assessment: action.data } },
                    }

                case 'pillarSelected':
                    return {
                        ...state,
                        appState: {
                            ...appState,
                            onboardingAnswers: { ...appState.onboardingAnswers, pillarSelected: action.data },
                        },
                    }
                case 'goalTag':
                    return {
                        ...state,
                        appState: { ...appState, onboardingAnswers: { ...appState.onboardingAnswers, goalTag: action.data } },
                    }
                case 'demographic':
                    return {
                        ...state,
                        appState: {
                            ...appState,
                            onboardingAnswers: {
                                ...appState.onboardingAnswers,
                                postCode: action.data.postCode,
                                genderIdentity: action.data.genderIdentity,
                                yearOfBirth: action.data.yearOfBirth,
                            },
                        },
                    }
                case 'routeChoice':
                    return {
                        ...state,
                        appState: {
                            ...appState,
                            onboardingAnswers: { ...appState.onboardingAnswers, postOnboardingNavigationChoice: action.data },
                        },
                    }
                default:
                    break
            }
        case ACTIONS.GET_ASSESSMENT_LIST:
            return {
                ...state,

                database: { ...database, onboardingTemplate: { ...database.onboardingTemplate, assessmentList: action.data } },
            }
        case ACTIONS.GET_ASSESSMENT.START:
            return {
                ...state,
                appState: { ...newAppState, getAssessmentLoading: true },
            }
        case ACTIONS.GET_ASSESSMENT.SUCCESS:
            const assessmentObject = action.data
            database.assessmentsIds.push(assessmentObject.userId)
            database.assessments.push(assessmentObject.assessment)
            database.assessmentsDates.push(assessmentObject.datastamp)
            // Parse from object to array
            Object.keys(assessmentObject.assessment).forEach(val => (newAppState.answers[parseInt(val)] = assessmentObject.assessment[val]))
            return {
                ...state,
                appState: { ...newAppState, getAssessmentLoading: false },
            }
        case ACTIONS.GET_ASSESSMENT.FAILURE:
            return {
                ...state,
                appState: { ...newAppState, getAssessmentLoading: false },
            }

        case ACTIONS.GET_ASSESSMENT_UPDATES.START:
            return {
                ...state,
                appState: { ...newAppState, getAssessmentUpdatesLoading: true },
            }
        case ACTIONS.GET_ASSESSMENT_UPDATES.SUCCESS:
            return {
                ...state,
                appState: { ...newAppState, getAssessmentUpdatesLoading: true, getAssessmentUpdatesError: null },
                database: { ...state.database, assessmentsUpdate: action.data },
            }
        case ACTIONS.GET_ASSESSMENT_UPDATES.FAILURE:
            return {
                ...state,
                appState: { ...newAppState, getAssessmentUpdatesLoading: true, getAssessmentUpdatesError: action.error },
            }

        case ACTIONS.SET_ANSWER_FORMAT:
            newAppState.answers[index] = {
                questionId: index.toString(),
                answerSelectedId: '',
                section: assessment[index],
                nextQuestion: 0,
            }
            return {
                ...state,
                appState: { ...newAppState },
            }
        case ACTIONS.SET_ANSWER:
            // eslint-disable-next-line no-case-declarations
            const { answerSelectedId, section } = newAppState.answers[index]
            // eslint-disable-next-line no-case-declarations
            let ansId = ''
            switch (section.answerType) {
                case ANSWERS.MULTIPLE_CHOICE:
                    const noneId = database.assessmentTemplate.assessment[index].answers.filter(answer => answer.text === 'None')[0].id || ''
                    const preferNotId =
                        database.assessmentTemplate.assessment[index].answers.filter(answer => answer.text.toLowerCase().includes('prefer not'))[0]
                            .id || ''

                    // If None is selected, deselect all other answers
                    if (action.answer === noneId || action.answer === preferNotId) {
                        if (answerSelectedId.includes(`.${action.answer}.`)) {
                            ansId = ''
                        } else {
                            ansId = `.${action.answer}.`
                        }
                    } else if (answerSelectedId.includes(`.${action.answer}.`)) {
                        // remove the tick if already present
                        ansId = answerSelectedId.replace(`.${action.answer}.`, '')
                    } else {
                        // add a tick, and remove None if selected
                        ansId = `${answerSelectedId}  .${action.answer}.`.replace(`.${noneId}.`, '').replace(`.${preferNotId}.`, '')
                    }
                    newAppState.answers[index] = {
                        ...appState.answers[index],
                        answerSelectedId: ansId,
                        nextQuestion: section.answers[0].nextQuestion,
                    }
                    break
                case ANSWERS.CONTINUE_BUTTON:
                    newAppState.answers[index] = {
                        ...newAppState.answers[index],
                        answerSelectedId: action.answer.id,
                        nextQuestion: section.answers[action.answer.id].nextQuestion,
                    }
                    break
                case ANSWERS.SINGLE_CHOICE:
                case ANSWERS.LIKERT_NUMBER:
                    newAppState.answers[index] = {
                        ...newAppState.answers[index],
                        answerSelectedId: action.answer,
                        nextQuestion: section.answers[action.answer].nextQuestion,
                    }
                    break
                case ANSWERS.NUMBER:
                case ANSWERS.TEXT:
                    newAppState.answers[index] = {
                        ...newAppState.answers[index],
                        answerSelectedId: action.answer,
                        nextQuestion: section.answers[0].nextQuestion,
                    }
                    break
                case ANSWERS.RANKING:
                    newAppState.answers[index] = {
                        ...newAppState.answers[index],
                        answerSelectedId: `${answerSelectedId}  ${action.answer}`,
                        nextQuestion: 1,
                    }
                    break
                case ANSWERS.PILLAR_GOALS:
                case ANSWERS.PILLAR_LIST:
                    newAppState.answers[index] = {
                        ...newAppState.answers[index],
                        answerSelectedId: action.answer,
                        nextQuestion: 1,
                    }
                    break
                default:
                    break
            }
            return {
                ...state,
                database,
                appState: { ...newAppState },
            }

        case ACTIONS.SET_ANSWER_OPEN_TEXT:
            newAppState.answers[index].openText = action.data

            return {
                ...state,
                database,
                appState: newAppState,
            }

        case ACTIONS.SET_NEXT_QUESTION:
            appState.index = action.data // index next question
            newAppState = {
                ...newAppState,
                index: action.data,
            }
            if (!newAppState.answers[action.data] || !('answerSelectedId' in newAppState.answers[action.data])) {
                newAppState.answers[action.data] = {
                    questionId: action.data.toString(),
                    answerSelectedId: '',
                    section: assessment[action.data],
                    nextQuestion: 0,
                }
            }
            return {
                ...state,
                appState: { ...newAppState },
            }

        case ACTIONS.POST_ASSESSMENT_UPDATE.START:
            return {
                ...state,
                appState: { ...newAppState, postingAssessmentUpdate: true },
            }
        case ACTIONS.POST_ASSESSMENT_UPDATE.SUCCESS:
            return {
                ...state,
                appState: { ...newAppState, postingAssessmentUpdate: false, postAssessmentUpdateError: null },
            }
        case ACTIONS.POST_ASSESSMENT_UPDATE.FAILURE:
            return {
                ...state,
                appState: { ...newAppState, postingAssessmentUpdate: false, postAssessmentUpdateError: action.error },
            }

        default:
            return state
    }
}
